import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Link, useNavigate } from "react-router-dom";

const BASE = process.env.REACT_APP_BACKEND_URL + "/api";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await axios.post(`${BASE}/admin/login`, { email, password });
      localStorage.setItem("sw_admin_token", data.token);
      localStorage.setItem("sw_admin", JSON.stringify(data.admin));
      navigate("/admin");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Invalid credentials");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-900 grid place-items-center px-4">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <div className="text-3xl font-black text-white tracking-tight mb-1">Brainydo</div>
          <div className="text-slate-400 text-sm font-medium tracking-wide uppercase">Super Admin</div>
        </div>
        <div className="bg-white rounded-2xl p-8 shadow-2xl">
          <h1 className="text-[17px] font-bold text-slate-900 mb-6">Sign in to admin panel</h1>
          <form onSubmit={handleLogin} className="space-y-4">
            <div>
              <label className="block text-[11px] font-bold uppercase tracking-[0.15em] text-slate-500 mb-1.5">Email</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                autoFocus
                placeholder="admin@example.com"
                className="w-full h-10 px-3 border border-slate-200 rounded-xl text-[13.5px] focus:outline-none focus:ring-2 focus:ring-slate-900"
              />
            </div>
            <div>
              <label className="block text-[11px] font-bold uppercase tracking-[0.15em] text-slate-500 mb-1.5">Password</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="w-full h-10 px-3 border border-slate-200 rounded-xl text-[13.5px] focus:outline-none focus:ring-2 focus:ring-slate-900"
              />
            </div>
            <button
              type="submit"
              disabled={loading}
              className="w-full h-10 bg-slate-900 text-white rounded-xl text-[13.5px] font-semibold hover:bg-slate-700 disabled:opacity-50 transition active:scale-95 mt-2"
            >
              {loading ? "Signing in…" : "Sign in"}
            </button>
            <p className="text-center pt-1">
              <Link
                to="/admin/forgot-password"
                className="text-[12.5px] text-slate-500 hover:text-slate-900 underline underline-offset-2"
              >
                Forgot password?
              </Link>
            </p>
          </form>
        </div>
        <p className="text-center text-slate-600 text-xs mt-6">Restricted access — authorised personnel only</p>
      </div>
    </div>
  );
}
